import localStorageRepositories from "@/plugins/localStorageRepositories";
import arrowLeft from "@/assets/images/storeeel_arrow_left02.png";
import arrowRight from "@/assets/images/storeeel_arrow_right02.png";

export const circleOverlayAction = () => {

  const campaignId = window.storeeelItems?.id;
  if (localStorageRepositories.get('circleOverlay')?.get(campaignId)) return;

  // オーバーレイ要素生成
  const overlay = document.createElement('div');
  overlay.className = 'storeee_overlay';
  overlay.innerHTML = `
      <div class="storeee_button storeee_left"><span><img src="${arrowLeft}"></span></div>
      <div class="storeee_button storeee_right"><span><img src="${arrowRight}"></span></div>
    `;
  document.body.appendChild(overlay);

  document.querySelector('.storeee_left')?.addEventListener('click', () => {
    const wrapper = document.querySelector('.swiper-slide-active .slide-media-wrapper');
    if (wrapper) window.dispatchEvent(new CustomEvent('storeeel-custom-tap', { detail: { x: 0, wrapper } }));
  });

  document.querySelector('.storeee_right')?.addEventListener('click', () => {
    const wrapper = document.querySelector('.swiper-slide-active .slide-media-wrapper');
    if (wrapper) {
      const rect = wrapper.getBoundingClientRect();
      const movieWidth = rect.width || wrapper.clientWidth;
      window.dispatchEvent(new CustomEvent('storeeel-custom-tap', { detail: { x: movieWidth, wrapper } }));
    }
  });

  setTimeout(() => {
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = 'auto';
    });
  }, 500);

  // スタイル注入
  const style = document.createElement('style');
  style.setAttribute('data-storeee-overlay', 'true');
  style.textContent = `
      .storeee_overlay {
        opacity: 0;
        pointer-events: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        transition: opacity 1s ease-in-out;
        z-index: 100189999999;
      }
      .storeee_button {
        width: 40vw;
        height: 75vh;
        background-color:rgba(50, 50, 50, 0.65);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
      }
      .storeee_left {
        position: fixed;
        top: 50%;
        left: 0;
        transform:translateY(-50%);
        display: flex;
        margin-left: 10px;
        z-index: 100190000000;
      }
      .storeee_right {
        position: fixed;
        top: 50%;
        transform:translateY(-50%);
        right: 0;
        display: flex;
        margin-right: 10px;
        z-index: 100190000000;
      }

      .storeee_left img,
      .storeee_right img{
        width:40px;
      }

    `;
  document.head.appendChild(style);

  setTimeout(() => {
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    setTimeout(() => {
      overlay.remove();
      style.remove();
      localStorageRepositories.get('circleOverlay')?.set(campaignId);
    }, 1000);
  }, 2000);
};
